module.exports = __webpack_public_path__ + "static/media/ic_show_collect_hover.e7506aaa.svg";